import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/store";


interface SelectedUnit {
    id: number;
    isArchiveCabinet: boolean;
    isDeactivated: boolean;
}
interface MapState {
    allFilter: boolean;
    archiveCabinetFilter: boolean;
    deactivatedFilter: boolean;
    liveUnitFilter: boolean;
    selectedUnit: null | SelectedUnit;
}

const initialState: MapState = {
    allFilter: true,
    archiveCabinetFilter: true,
    deactivatedFilter: true,
    liveUnitFilter: true,
    selectedUnit: null,
};

export const mapSlice = createSlice({
    name: "map",
    initialState,
    reducers: {
        setAllFilter(state, action: PayloadAction<boolean>) {
            state.allFilter = action.payload;
        },
        setArchiveCabinetFilter(state, action: PayloadAction<boolean>) {
            state.archiveCabinetFilter = action.payload;
        },
        setDeactivatedFilter(state, action: PayloadAction<boolean>) {
            state.deactivatedFilter = action.payload;
        },
        setLiveUnitFilter(state, action: PayloadAction<boolean>) {
            state.liveUnitFilter = action.payload;
        },
        setSelectedUnit(state, action: PayloadAction<null | SelectedUnit>) {
            state.selectedUnit = action.payload;
        },
    },
});

export const { setAllFilter, setArchiveCabinetFilter, setDeactivatedFilter, setLiveUnitFilter, setSelectedUnit } =
    mapSlice.actions;

export const mapReducer = mapSlice.reducer;
export const mapSelectors = {
    getSelectedUnit: (state: RootState) => {
        return state.map.selectedUnit;
    },
    getSelectedUnitId: (state: RootState) => {
        return state.map.selectedUnit?.id;
    },
    getIsArchiveCabinet: (state: RootState) => {
        return state.map.selectedUnit?.isArchiveCabinet;
    },
    getIsDeactivated: (state: RootState) => {
        return state.map.selectedUnit?.isDeactivated;
    },
};
